/**
 * Servicio para manejar operaciones con PDFs
 */

/**
 * Abre un Blob PDF en una nueva ventana del navegador
 * @param pdfBlob - Blob que contiene el PDF
 * @param filename - Nombre opcional del archivo (se asegura la extensión .pdf)
 * Nota: La URL del blob no se revoca para mantener la pestaña abierta con el PDF visible
 */
export const openPdfInNewWindow = (pdfBlob: Blob, filename?: string): void => {
  if (!pdfBlob || !(pdfBlob instanceof Blob)) {
    console.error("Invalid PDF blob provided");
    return;
  }

  try {
    let fileToOpen: Blob | File = pdfBlob;
    
    // Si se proporciona un nombre, crear un File para que el navegador lo reconozca
    if (filename) {
      const finalFilename = filename.endsWith('.pdf') ? filename : `${filename}.pdf`;
      fileToOpen = new File([pdfBlob], finalFilename, { type: 'application/pdf' });
    }
    
    const url = URL.createObjectURL(fileToOpen);
    window.open(url, '_blank');
    // No se revoca la URL para permitir visualización continua del PDF en la pestaña nueva
  } catch (error) {
    console.error("Error opening PDF:", error);
  }
};

/**
 * Descarga un Blob PDF con un nombre de archivo específico
 * @param pdfBlob - Blob que contiene el PDF
 * @param filename - Nombre del archivo a descargar (se asegura la extensión .pdf)
 */
export const downloadPdf = (pdfBlob: Blob, filename: string): void => {
  if (!pdfBlob || !(pdfBlob instanceof Blob)) {
    console.error("Invalid PDF blob provided");
    return;
  }

  try {
    // Asegurar que el nombre tenga extensión .pdf
    const finalFilename = filename.endsWith('.pdf') ? filename : `${filename}.pdf`;
    
    const url = URL.createObjectURL(pdfBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = finalFilename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 100);
  } catch (error) {
    console.error("Error downloading PDF:", error);
  }
};
